export const WARRANT_ROUTE = '/warrants';
export const CASE_ROUTE = '/cases';
export const AF_ROUTE = '/afs';
export const CF_ROUTE = '/cfs';
export const CF_GROUP_ROUTE = '/cf-groups';
export const SYSTEM_CONFIGURATION_ROUTE = '/systemConfiguration';
export const DISTRIBUTORS_ROUTE = '/distributors';
export const SECURITY_GATEWAY_ROUTE = '/securityGateway';
export const DIALED_DIGIT_EXTRACTION_SERVER_ROUTE = '/dipms';
export const IRI_BUFFERING_ROUTE = '/iri-buffering';
export const UTIMACO_PACKET_SWITCH_ROUTE = '/utmpktcfcis';
export const UTIMACO_CIRCUIT_SWITCH_ROUTE = '/utmisdncfcis';
export const TARGET_DELIVERY_TEMPLATE_PER_ACCESS_FUNCTION = '/template-per-access-function';
export const NETWORK_ID_ROUTE = '/networkId';
export const RADIUS_PARSER_OPTIONS = '/rpoptions';
export const SSH_SECURITY_INFORMATION = '/ssh-info';
export const NAT_CONFIGURATION_ROUTE = '/nat-configuration';
export const TLS_PROFILE = '/tls-profile';
export const MEDIA_GATEWAY = '/media-gateway';
export const PROCESS_OPTIONS_ROUTE = '/process-options';
export const SYSTEM = '/system';
export const NETWORK = '/network';
export const SECURITY = '/security';
export const TARGET_TEMPLATE = '/targetTemplate';
export const MISCELLANEOUS = '/miscellaneous';
export const XDP = '/xdp';
export const TARGET_DOMAIN = '/target-domain';
export const PERIODIC_AUDIT_ROUTE = '/periodic-audit';
export const JURISDICTION_AREA = '/jurisdiction-area';
export const XCCA = '/xcca';
export const XCCA_DASHBOARD = '/xcca-dashboard';
export const CF_FTP_INFO_ROUTE = '/cf-ftp-infos';
export const FILTER_SETTING = '/filter-setting';
export const FILTER_GROUP = '/filter-group';
export const AF_FILTER = '/af-filter';
export const FILTERS = '/filters';
export const SIP_SETTING = '/sip-setting';
export const REGISTERED_NODES = '/registered-nodes';
export const BACKUP_RESTORE = '/backup-and-restore';
export const FQDN = '/fqdn';
export const XTP = '/xtp';
export const SECURITY_POLICY_ROUTE = '/security-policy';
export const XTP_XDP_CONNECTION = '/connection-between-xtp-and-xdp';
export const RADIUS_PARSER_PASSWORD = '/radius-parser-password';
export const NETWORK_TOPOLOGY = '/topology';
export const ALARM = '/alarms';
export const ALARM_NOTIFICATION_PROFILE = '/alarm-notification-profile';
export const AFWHITELIST = '/afwhitelist'
export const SNMP_USERS = '/snmp-users';
export const SNMP_DEST = '/snmp-destinations';
export const CONTACT = '/contact';
export const EWARRANT_ROUTE = '/eWarrant';
export const CSP_CONFIG_ROUTE = '/csp-configs';
export const TENANT_ROUTE = '/tenants';
